export enum EnumEstimateStatus {
  DEMANDS = 'Demandes',
  ESTIMATE = 'Devis'
}